import { deleteReq, putReq, postReq } from '../api/restHelper';
import moment from 'moment';
import { getWsRecords, updateRecordsOfMainPage } from './app';
import { toast } from 'react-toastify'
import { creatStartEnd } from '../api/timeListProcess'

const start = (obj, dispatch)=>{

    dispatch({ type : 'START_TIMER_LOADING', payload : {}})
    const sendObj = { ...obj};
    if(sendObj.project.id){
        sendObj.project = sendObj.project.id
    }else{
        delete sendObj.project
    }
        postReq( sendObj, 'record' , (res)=>{
            dispatch({ type : 'SET_ACTIVE_RECORD', payload : res.data})
            dispatch({ type : 'STOP_TIMER_LOADING', payload : {}})
        }, ()=>{
            dispatch({ type : 'REMOVE_ACTIVE_RECORD', payload : {} })
            dispatch({ type : 'STOP_TIMER_LOADING', payload : {}})
         });
}

export function toggleTimerMode(status){
    return (dispatch) => {
        dispatch({type : 'TOGGLE_TIMER_MODE', payload : {status}})
    }
}

export function deleteActiveRecord(id){
    return (dispatch) => {
        dispatch({ type : 'START_TIMER_LOADING', payload : {}})
        deleteReq('record/' + id, ()=>{
            dispatch({ type : 'REMOVE_ACTIVE_RECORD', payload : {} })
            dispatch({ type : 'STOP_TIMER_LOADING', payload : {}})
        }, ()=>{
            dispatch({ type : 'STOP_TIMER_LOADING', payload : {}})
        });
    }
}

export function deleteRecord(id){
    return (dispatch, getState) => {
        deleteReq('record/' + id, ()=>{
            getWsRecords();
        });
    }
}

export function stopRecord(record){
    return (dispatch, getState) => {
        dispatch({ type : 'START_TIMER_LOADING', payload : {}})
        var recordObj = {
            name : record.name,
            start : record.start,
            end : moment().locale('en').format('YYYY-MM-DDTHH:mm:ss'),
            workspace : getState().app.work_space.id,
            project : record.project.id
        }
        putReq( recordObj, 'record/' + record.id , (res)=>{
            dispatch({ type : 'REMOVE_ACTIVE_RECORD', payload : {} })
            dispatch({ type : 'STOP_TIMER_LOADING', payload : {}})
            getWsRecords()
        }, ()=>{});
    }
}

export function startRecord(){
    return (dispatch, getState) => {
        const state = getState();
        let recordObj = {
            name : state.timer.active_record.name,
            start : moment().locale('en').format('YYYY-MM-DDTHH:mm:ss'),
            workspace : state.app.work_space.id,
            project : state.timer.active_record.project
        }
        start(recordObj, dispatch);
    }
}

export function addRecord(){
    return (dispatch, getState) => {
        const state = getState();
        let recordObj = {
            name : state.timer.manual_record.name,
            start : moment().locale('en').format('YYYY-MM-DDTHH:mm:ss'),
            workspace : state.app.work_space.id,
            project : state.timer.active_record.project
        }
        start(recordObj, dispatch);
    }
}

export function startSameRecord(templateRecord){
    return (dispatch, getState) => {
        const state = getState();
        if( !state.timer.timer_loading ){
            let recordObj = {
                name : templateRecord.name,
                start : moment().locale('en').format('YYYY-MM-DDTHH:mm:ss'),
                workspace : state.app.work_space.id,
                project : templateRecord.project
            }
            start(recordObj, dispatch);
            dispatch({type : 'TOGGLE_TIMER_MODE', payload : {status:false}})
        }
        
    }
}

export function selectRecordProject(obj, record){
    return (dispatch, getState) => {
        if( (!record.end && record.start) || (!record.start && !record.id && !getState().timer.manual)){
            dispatch({ type : 'SET_ACTIVE_RECORD_PROJECT', payload: obj})
            const activeRecord = getState().timer.active_record;
            if(activeRecord.id){
                dispatch({ type : 'START_TIMER_LOADING', payload : {}})
                const sendObj = Object.assign({}, activeRecord)
                delete sendObj.id;
                delete sendObj.user;
                sendObj.project = obj.id
                sendObj.workspace = getState().app.work_space.id
                putReq( sendObj, 'record/' + activeRecord.id , (res)=>{
                    dispatch({ type : 'SET_ACTIVE_RECORD', payload : res.data})
                    dispatch({ type : 'STOP_TIMER_LOADING', payload : {}})
                }, ()=>{
                    dispatch({ type : 'STOP_TIMER_LOADING', payload : {}})
                });
            }
        }else if(record.end && record.start){
            const state = getState();
            let sendObj = { ...record };

            delete sendObj.user;
            delete sendObj.id;
            delete sendObj.index;
            delete sendObj.duration;

            sendObj.project = obj.id;
            sendObj.workspace = state.app.work_space.id

            putReq( sendObj, 'record/' + record.id , (res)=>{
                dispatch({ type : 'UPDATE_RECORD', payload : { data:res.data, index:record.index }})
                updateRecordsOfMainPage(state.timer.records.list,state.app.display_duration);
            }, ()=>{
                dispatch({ type : 'UPDATE_RECORD', payload : { data:record, index:record.index }})
                updateRecordsOfMainPage(state.timer.records.list,state.app.display_duration);
            });
        }else if(getState().timer.manual){
            dispatch({ type : 'SET_MANUAL_RECORD_PROJECT', payload: obj})
        }
        
    }
}

export function setActiveRecordTitle(name){
    return (dispatch, getState) => {
        const state = getState();
        if(state.timer.active_record.name !== name){
            dispatch({ type : 'SET_ACTIVE_RECORD_NAME', payload: name})
            if(state.timer.active_record.id){
                dispatch({ type : 'START_TIMER_LOADING', payload : {}})
                var recordObj = {
                    name : name,
                    start : state.timer.active_record.start,
                    workspace : state.app.work_space.id,
                    project : state.timer.active_record.project.id
                }
                putReq( recordObj, 'record/' + state.timer.active_record.id , (res)=>{
                    dispatch({ type : 'SET_ACTIVE_RECORD', payload : res.data})
                    dispatch({ type : 'STOP_TIMER_LOADING', payload : {}})
                }, ()=>{
                    dispatch({ type : 'STOP_TIMER_LOADING', payload : {}})
                });
            }else{
                startRecord();
            }
        }
    }
}

export function updateRecord(obj={}){
    return (dispatch, getState) => {
        
        const state = getState();
        let sendObj = { ...obj };

        delete sendObj.user;
        delete sendObj.id;
        delete sendObj.index;
        delete sendObj.duration;
        delete sendObj.open;

        sendObj.project = obj.project.id;
        sendObj.workspace = state.app.work_space.id

        putReq( sendObj, 'record/' + obj.id , (res)=>{
            dispatch({ type : 'UPDATE_RECORD', payload : { data:res.data, index:obj.index }})
            updateRecordsOfMainPage(state.timer.records.list,state.app.display_duration);
        }, ()=>{
            dispatch({ type : 'UPDATE_RECORD', payload : { data:obj, index:obj.index }})
            updateRecordsOfMainPage(state.timer.records.list,state.app.display_duration);
        });
    }
}

export function updateActiveRecordStart(time, activeRecord){
    return (dispatch, getState) => {
        const nowTime = moment().locale('en');
        const updatingTime = moment(time, 'HH:mm').locale('en');
        let startTime = moment(activeRecord.start).locale('en');
        if( moment.duration(nowTime.diff(updatingTime)).asSeconds() > 0){
            const breakTime = time.split(':');
            startTime = startTime.set({hours:breakTime[0], minute:breakTime[1], second:0}).format('YYYY-MM-DDTHH:mm:ss');
            dispatch({ type : 'START_TIMER_LOADING', payload : {}})
            dispatch({ type : 'SET_ACTIVE_RECORD', payload : Object.assign({}, activeRecord, {start:startTime}) })

            var recordObj = {
                name : activeRecord.name,
                start : startTime,
                workspace : getState().app.work_space.id,
                project : activeRecord.project.id
            }
            putReq( recordObj, 'record/' + activeRecord.id , (res)=>{
                dispatch({ type : 'SET_ACTIVE_RECORD', payload : res.data })
                dispatch({ type : 'STOP_TIMER_LOADING', payload : {}})
            }, ()=>{});
        }else{
            toast.error("امکان تغییر زمان شروع به زمانی جلوتر از زمان فعلی وجود ندارد.");
        }
    }
}

export function addManualRecord(record={}, clearState = ()=>{}){
    return (dispatch, getState) => {
        dispatch({ type : 'START_TIMER_LOADING', payload : {}})
        let sendObj = {
            name : record.name,
            start : record.start,
            end : moment().locale('en').format('YYYY-MM-DDTHH:mm:ss'),
            workspace : getState().app.work_space.id,
        }
        const startEnd = creatStartEnd( record.startTime, record.endTime, record.date )
        sendObj = Object.assign( {}, sendObj, startEnd)
        if(record.project){
            sendObj.project = record.project.id
        }
        postReq( sendObj, 'record', (res)=>{
            dispatch({ type : 'STOP_TIMER_LOADING', payload : {}});
            clearState();
            getWsRecords();
        }, (res)=>{
            dispatch({ type : 'STOP_TIMER_LOADING', payload : {}});
        });
    }
}
